export default {
  namespaced: true,

  state: {
    hasData: false,
    edit: [],
    info: [],
    updateKey: 0,
    token: false,
  },

  mutations: {
    HAS_DATA(state, bool) {
      state.hasData = bool;
    },

    SET(state, project) {
      state.info = project;
    },

    PATCH(state, project) {
      state.info.name = project.name;
      state.info.description = project.description;
    },

    EDIT(state, project) {
      state.edit = project;
    },

    SET_TOKEN(state, token) {
      state.token = token;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },
  },

  actions: {
    SET(context, projects) {
      context.commit('SET', projects);
    },

    PATCH(context, project) {
      context.commit('PATCH', project);
    },
  }
}
